export { ContentPage as default } from '@moonpig/web-explore-find'
